<template>
  <div>LayoutHerder</div>
</template>

<script>
export default {
  name: 'Layout',
  props: {
    route: {
      type: Object,
      default: () => ({}),
    },
    context: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
